import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService, FormUrlEncoder } from '@keystone-angular/core';
import pickBy from 'lodash-es/pickBy';
import { Observable } from 'rxjs';
import { InventoryTransfer } from '../../product/models/inventory-transfer';

@Injectable({
  providedIn: 'root'
})
export class ReceiveGoodsDataService {
  private baseUrl = 'v2/flow-of-goods/purchase-order';

  constructor(private dataService: DataService) { }

  add(): Observable<any> {
    return this.dataService.get(`${this.baseUrl}/add`);
  }

  addSimpleOrder(data: any): Observable<any> {
    return this.dataService.post(`${this.baseUrl}/simple/add`, data);
  }

  addTwoStepOrder(data: any): Observable<any> {
    return this.dataService.post(`${this.baseUrl}/twostep/add`, data);
  }

  hasReceivedAll(orderId: number): Observable<any> {
    return this.dataService.get(`${this.baseUrl}/hasReceivedAll?orderId=${orderId}`);
  }
  getDelivery(deliveryId: number): Observable<any> {
    return this.dataService.get(`${this.baseUrl}/deliveries/${deliveryId}`);
  }

  getFilters(): Observable<any> {
    return this.dataService.get(`${this.baseUrl}/filters`);
  }

  getPrintedSerialz(orderId: any, productId: any): Observable<any> {
    return this.dataService.get(`${this.baseUrl}/printedSerialz`, {
      params: new HttpParams({
        fromObject: pickBy({
          orderId,
          productId
        })
      })
    });
  }

  getPurchaseOrderJournal(id: any): Observable<any> {
    return this.dataService.get(`${this.baseUrl}/journal/${id}`);
  }

  addCorrectionOrder(correctionOrder: any): Observable<any> {
    return this.dataService.post(`${this.baseUrl}/correction`, correctionOrder);
  }

  addTransferOrder(inventoryTransfer: InventoryTransfer): Observable<any> {
    return this.dataService.post(`${this.baseUrl}/transfer/add`, inventoryTransfer);
  }

  getUnprintedSerialz(orderId: any): Observable<any> {
    return this.dataService.get(`${this.baseUrl}/unprintedSerialz`, {
      params: new HttpParams({
        fromObject: pickBy({
          orderId
        })
      })
    });
  }

  moveToPending(purchaseOrderId: any): Observable<any> {
    return this.dataService.post(`${this.baseUrl}/movePending`, { id: purchaseOrderId });
  }

  pageAllPurchaseOrders(page: number, count: number, search: string): Observable<any> {
    return this.dataService.get(`${this.baseUrl}/pageAll`, {
      params: new HttpParams({
        encoder: new FormUrlEncoder(),
        fromObject: pickBy({
          count: count.toString(),
          page: page.toString(),
          search
        })
      })
    });
  }

  pageCompletedPurchaseOrders(page: number, count: number, search: string): Observable<any> {
    return this.dataService.get(`${this.baseUrl}/pageCompleted`, {
      params: new HttpParams({
        encoder: new FormUrlEncoder(),
        fromObject: pickBy({
          count: count.toString(),
          page: page.toString(),
          search
        })
      })
    });
  }

  pagePendingPurchaseOrders(page: number, count: number, search: string): Observable<any> {
    return this.dataService.get(`${this.baseUrl}/pagePending`, {
      params: new HttpParams({
        encoder: new FormUrlEncoder(),
        fromObject: pickBy({
          count: count.toString(),
          page: page.toString(),
          search
        })
      })
    });
  }

  receiveInventory(data: any): Observable<any> {
    return this.dataService.post(`${this.baseUrl}/receiveInventory`, data);
  }

  registerPrintedLabels(data: any): Observable<any> {
    return this.dataService.post(`${this.baseUrl}/registerPrintedLabels`, data);
  }

  removePurchaseOrder(orderId: number, comment: string): Observable<any> {
    return this.dataService.post(`${this.baseUrl}/void`, {
      comment,
      orderId
    });
  }

  searchProductsSuggestions(query: any, brandId: any, seasonId: any): Observable<any> {
    return this.dataService.get(`${this.baseUrl}/products`, {
      params: new HttpParams({
        fromObject: pickBy({
          brandId,
          query,
          seasonId
        })
      })
    });
  }

  updateSimpleOrder(data: any): Observable<any> {
    return this.dataService.post(`${this.baseUrl}/simple/edit`, data);
  }

  updateTwoStepOrder(data: any): Observable<any> {
    return this.dataService.post(`${this.baseUrl}/twostep/edit`, data);
  }
}
